import { isDominoTask } from './dailyTaskTypes';

export function liveTaskIdFromTodayItem(task) {
  return Number(task?.liveTask?.id || task?.task_id || task?.id) || null;
}

export function isMaterialShort(item) {
  const requested = Number(item?.quantity || 0);
  const released = Number(item?.releasedQuantity ?? item?.quantityReleasedOnDate ?? 0);
  const status = String(item?.status || '').toLowerCase();
  if (status.includes('critical') || status.includes('pending') || status.includes('short')) {
    return true;
  }
  return requested > 0 && released < requested;
}

export function liveTaskIdFromMaterial(item) {
  return Number(item?.dailyRequirement?.task_id || item?.task_id) || null;
}

export function toRequirementSelectedTask(task, dailyTasks = []) {
  if (!task) return null;

  const liveId = liveTaskIdFromTodayItem(task);
  const daily = (dailyTasks || []).find(
    (row) => Number(row.task_id) === liveId || Number(row.liveTask?.id) === liveId
  );

  return {
    id: daily?.id || task.dailyTaskOnDate?.id || task.id,
    task_id: liveId || task.task_id,
    liveTask: daily?.liveTask || task.liveTask || { id: liveId, name: task.name },
    name: task.name || daily?.liveTask?.name || daily?.name
  };
}

export function splitDailyTasksForToday(rows) {
  const inProgress = [];
  const delayed = [];

  (Array.isArray(rows) ? rows : []).forEach((row) => {
    if (!row || row.status === 'Completed') return;
    if (isDominoTask(row)) return;

    const item = {
      id: row.task_id || row.liveTask?.id,
      name: row.liveTask?.name || row.name,
      workType: row.liveTask?.workType || null,
      dailyTaskOnDate: {
        id: row.id,
        name: row.name,
        date: row.date,
        status: row.status,
        type: row.type
      },
      status: row.liveTask?.status || row.status
    };

    if (row.isEscalated || row.type === 'Escalated') {
      delayed.push(item);
      return;
    }

    if (
      row.isUpdate ||
      row.type === 'Updates' ||
      row.type === 'default' ||
      row.type === 'Kickstart' ||
      row.type === 'Date'
    ) {
      inProgress.push(item);
    }
  });

  return { inProgress, delayed };
}

export function pickTodayBuckets({ stats, dailyRows, statsFailed }) {
  const fromStats = {
    inProgress: stats?.todaysWorkBlock?.inProgress || [],
    delayed: [
      ...(stats?.todaysWorkBlock?.delayedAtStart || []),
      ...(stats?.todaysWorkBlock?.delayedDuringTask || [])
    ]
  };
  const fromDaily = splitDailyTasksForToday(dailyRows);
  const statsEmpty = fromStats.inProgress.length + fromStats.delayed.length === 0;

  if (statsFailed || statsEmpty) {
    return {
      inProgress: fromDaily.inProgress,
      delayed: fromDaily.delayed,
      source: statsFailed ? 'daily-fallback' : 'daily-empty-stats'
    };
  }

  return { ...fromStats, source: 'stats' };
}

export function applyMaterialBlock(tasks, blockedList = []) {
  const byId = new Map(
    (blockedList || []).map((row) => [Number(row.id || row.task_id), row])
  );
  return (tasks || []).map((task) => {
    const hit = byId.get(Number(task.id)) || byId.get(Number(task.liveTask?.id));
    if (!hit && !task.material_blocked) return task;
    return {
      ...task,
      material_blocked: Boolean(task.material_blocked || hit),
      material_block_item: task.material_block_item || hit?.material_block_item || null
    };
  });
}

export function blockedTasksAsShortItems(blockedList = []) {
  return (blockedList || []).map((task) => ({
    id: `blocked-${task.id}`,
    item: { item_name: task.material_block_item || 'Material' },
    itemName: task.material_block_item || 'Material',
    quantity: null,
    releasedQuantity: null,
    dailyRequirement: { task_id: task.id },
    task_id: task.id,
    liveTask: { id: task.id, name: task.name },
    name: task.name,
    material_blocked: true,
    material_block_item: task.material_block_item || null
  }));
}
